import juice from 'juice';
import cssjs from 'jotform-css.js';

export default {
    getHeadInner(html) {
        if (!html) return '';

        const dom = (new DOMParser()).parseFromString(html, "text/html");
        const head = dom.querySelector('head');

        if (head) {
            return dom.querySelector('head').innerHTML;
        }

        return '';
    },

    getBodyInner(html) {
        if (!html) return '';

        const dom = (new DOMParser()).parseFromString(html, "text/html");
        const body = dom.querySelector('body');
        const bogusDivs = dom.querySelectorAll('div[data-mce-bogus="all"]:empty');
        for (let bogusDiv of bogusDivs) {
            bogusDiv.style.display = 'none';
        }

        if (body) {
            return dom.querySelector('body').innerHTML;
        }

        return '';
    },

    stringToDom(html) {
        if (!html) return '';

        return (new DOMParser()).parseFromString(html, "text/html");
    },

    buildDocument(options, hasHtmlTag = false) {
        let parts = Object.assign({
            html: '',
            head: '',
            body: ''
        }, options);

        if (!hasHtmlTag) {
            return options.body;
        }

        const dom = (new DOMParser()).parseFromString(parts.html, "text/html");
        const domBody = (new DOMParser()).parseFromString(parts.body, 'text/html');
        const bogusDivs = domBody.querySelectorAll('.mce-visual-caret-hidden, .mce-visual-caret');
        if (bogusDivs.length > 0) {
            bogusDivs.forEach((element) => {
                element.remove();
            });
        }
    
        dom.querySelector('head').innerHTML = parts.head;
        dom.querySelector('body').innerHTML = domBody.body.innerHTML;

        return dom.querySelector('html').outerHTML;
    },

    hasHtmlTag(html = '') {
        return html.indexOf('<html') > -1;
    },

    getHtmlParts(html = '') {
        const htmlWithNoContentBefore = this.detachHtmlFromContentBefore(html);

        return {
            contentBefore: this.detachContentBeforeHtmlTag(html),
            head: this.getHeadInner(htmlWithNoContentBefore),
            body: this.getBodyInner(htmlWithNoContentBefore)
        }
    },

    detachContentBeforeHtmlTag(html = '') {
        const htmlIndex = html.indexOf('<html');

        if (!html || htmlIndex < 0) {
            return '';
        }

        return html.substring(0, htmlIndex);
    },

    detachHtmlFromContentBefore(html = '') {
        const htmlIndex = html.indexOf('<html');

        if (!html || htmlIndex < 0) {
            return html;
        }

        return html.substring(htmlIndex, html.length - 1);
    },

    attachContentBeforeHtml(html, content) {
        return content + html;
    },

    formatDocument(options) {
        options = {
            html: '',
            head: '',
            body: '',
            css: '',
            contentBefore: '',
            keepElementIds: false,
            hasHtmlTag: false,
            inline: true,
            useStyleTags: true,
            prependToBody: null,
            filterCssRules: false,
            ...options
        };

        if (options.hasHtmlTag) {
            options.contentBefore = this.regexRemoveStyleTag(options.contentBefore);
        }

        if (typeof options.filterCssRules === 'function') {
            const cssJson = this.cssToJson(options.css);
            const newCss = this.filterCssRules(cssJson, options.filterCssRules);
            const parser = new cssjs.cssjs();
            options.css = parser.getCSSForEditor(newCss);
        }

        options.contentBefore = options.contentBefore.trim();

        options.html = this.buildDocument(options, options.hasHtmlTag);

        if (options.css && options.inline) {
            if (options.useStyleTags) {
                options.html = this.inlineDocument(options.html, options.css);
            } else {
                options.html = this.inlineBlock(options.body, options.css);
            }
        }

        if (options.keepElementIds !== false) {
            options.html = this.stripElementIdsExcept(options.html, options.keepElementIds, options.hasHtmlTag);
        }

        if (!options.inline && options.css && !options.hasHtmlTag) {
            options.html = `
                <style>
                    ${options.css}
                </style>

                ${options.html}
            `;
        }

        if (options.prependToBody != null) {
            options.html = this.prependToBody(options.html, options.prependToBody);
        }

        return this.attachContentBeforeHtml(options.html, options.contentBefore);
    },

    regexRemoveStyleTag(content = '') {
        var regex = /((<style>)|(<style type=.+))((\s+)|(\S+)|(\r+)|(\n+))(.+)((\s+)|(\S+)|(\r+)|(\n+))(<\/style>)/g;
        return content.replace(regex, '');
    },

    filterCssRules(arr, callback) {
        return arr.map(item => {
            if (item.subStyles) {
                item.subStyles = item.subStyles.map(sub => {
                    sub.rules = sub.rules.filter(callback);
                    return sub;
                });
            } else {
                item.rules = item.rules.filter(callback);
            }

            return item;
        });
    },

    formatBlockDocument(options) {
        options = {
            contentBefore: '',
            html: '',
            head: '',
            body: '',
            ...options
        };

        // this fixes the block preview html so it can be properly rendered to a preview image in pdfReactor
        const dom = (new DOMParser()).parseFromString(options.body, "text/html");
        const imgs = dom.querySelectorAll('center > img');

        if (imgs.length) {
            for (var i = imgs.length - 1; i >= 0; i--) {
                imgs[i].parentElement.style.width = null;
                imgs[i].parentElement.style.minWidth = null;
            }

            options.body = dom.querySelector('body').innerHTML;
        }

        return this.attachContentBeforeHtml(
            this.buildDocument(options, true),
            options.contentBefore
        );
    },

    inlineDocument(html, css) {
        return juice(this.getHtmlWithStyleTag(html, css), {
            applyAttributesTableElements: false,
            applyHeightAttributes: false,
            applyWidthAttributes: false,
        });
    },

    inlineBlock(html, css) {
        return juice.inlineContent(html, css, {
            applyAttributesTableElements: false,
            applyHeightAttributes: false,
            applyWidthAttributes: false
        });
    },

    getHtmlWithStyleTag(html, css) {
        const styleRegex = /(<style>(.|\n|\r)*?<\/style>)/m;
        const resetHtml = html.replace(styleRegex, '');
        const styleTagHtml = resetHtml.replace('<meta name="viewport" content="width=device-width">', `<meta name="viewport" content="width=device-width"> 
        <style>${css}</style>`);
        return styleTagHtml;
    },

    prefixHtmlWithStyleTag(html, css) {
        return ` <style>${css}</style> ${html}`;
    },

    stripElementIdsExcept(html, keepIds = [], hasHtmlTag = false) {
        const dom = (new DOMParser()).parseFromString(html, "text/html");
        const elements = dom.querySelectorAll('*');

        // might be a good place to strip out gjs-selected class
        // strip out data-highlightable

        for (var i = elements.length - 1; i >= 0; i--) {
            if (keepIds.includes(elements[i].getAttribute('id'))) {
                continue;
            } else {
                elements[i].removeAttribute('id');
            }
        }

        if (hasHtmlTag) {
            return dom.documentElement.outerHTML;
        }

        return dom.body.innerHTML;
    },

    extractStyles(html) {
        if (!html) {
            return ''
        }
        let css = '';
        const dom = this.stringToDom(html);
        // workaround .forEach() missing on NodeList in IE11
        // TODO: consider a polyfill for this
        const styleTags = Array.prototype.slice.call(dom.querySelectorAll('style'), 0);
        styleTags.forEach(style => {
            css += style.innerHTML;
        });

        return css;
    },

    removeStyleTags(html) {
        const dom = this.stringToDom(html);

        // workaround .forEach() missing on NodeList in IE11
        // TODO: consider a polyfill for this
        const styleTags = Array.prototype.slice.call(dom.querySelectorAll('style'), 0);

        styleTags.forEach(style => {
            // Remove doesn't exist in node elements in IE11
            // TODO: Consider a polyfill for this
            if (typeof style.remove === 'function') {
                style.remove();
              } else {
                style.parentNode.removeChild(style);
              }
        });

        return dom;
    },

    replaceStyles(html, css, contentBefore = '') {
        if (!html) {
            return ''
        }
        if (!css && !contentBefore) {
            return html;
        }

        let body = this.removeStyleTags(html).querySelector('body').innerHTML;

        return `
            ${contentBefore}

            <style>
                ${css}
            </style>

            ${body}
        `;
    },

    cssToJson(css) {
        const parser = new cssjs.cssjs();
        return parser.parseCSS(css);
    },

    filterCssIds(css, compare = []) {
        const parser = new cssjs.cssjs();
        let json = parser.parseCSS(css);
        compare = compare.map(item => item.replace('#', ''));

        const matched = json.filter(item => {
            return compare.includes(item.selector.replace('#', ''));
        });

        return parser.getCSSForEditor(matched);
    },

    removeAllAttr(el, attrs = []) {
        const elements = el.querySelectorAll('*');

        for (var i = elements.length - 1; i >= 0; i--) {
            attrs.forEach(item => {
                elements[i].removeAttribute(item);
            });
        }

        return el;
    },

    iterateCss(arr, callback) {
        arr.forEach(item => {
            if (item.rules) {
                item.rules.forEach(callback);
            } else if (item.subStyles) {
                item.subStyles.forEach(sub => {
                    sub.rules.forEach(callback);
                });
            }
        });

        return arr;
    },

    getPxPerMm() {
        const mm = 100000;
        let $el = $('.js-mm');

        if (!$el.length) {
            $('body').append(`<div style="height: ${mm}mm;" class="js-mm"></div>`);
            $el = $('.js-mm');
        }

        return $el.height() / mm;
    },

    // expects array from css.js parser.parseCSS
    pxToMm(selectors) {
        const pxPerMm = this.getPxPerMm();

        return this.iterateCss(selectors, rule => {
            if (rule.value.indexOf('px') > -1) {
                rule.value = rule.value.split(' ').map(item => {
                    if (this.isTranslateRule(item)) {
                        const currentValue = this.getRuleValue(item);
                        const updatedValue = currentValue.split(",").map(item => {
                            return (parseFloat(item.trim()) / pxPerMm) + 'mm';
                        }).join(", ");

                    return item.replace(currentValue, updatedValue);
                    } else {
                        return (parseFloat(item) / pxPerMm) + 'mm';
                    }
                }).join(' ');
            }
        });
    },

    // Check if CSS rule is translate type
    isTranslateRule(value) {
        return value.indexOf('translate') > -1;
    },

    // Get css value enclosed within parenthesis
    getRuleValue(value) {
        return value.match(/\(([^)]+)\)/)[1];
    },

    /**
     * This parses a grapes style object to workaround
     * a grapes parsing bug with data url's
     */
    parseGrapesBackgroundImage(value) {
        if (!value['background-image']) return;

        let backgroundImage = value['background-image'];

        if (/url\(["']?data/.test(backgroundImage)) {
            const base64String = Object.keys(value).filter((key) => /^base64/.test(key));
            backgroundImage = `${value["background-image"]};${base64String}`;
        }

        return this.parseBackgroundImage(backgroundImage);
    },

    parseBackgroundImage(value) {
        if (!value) return;

        return value.replace(/(?:^url\(["']?|["']?\)$)/g, "");
    },

    prependToBody(html, prependObject) {
        const prependHtmlString = prependObject["html"] || "";
        const prependSelector = prependObject["selector"] || "";
        const dom = this.stringToDom(html);

        let existingElement = dom.querySelector(prependSelector);

        if (existingElement != null) {
            existingElement.parentNode.removeChild(existingElement);
        }

        let body = dom.querySelector('body');

        body.insertAdjacentHTML('afterbegin', prependHtmlString);
        return dom.querySelector('html').outerHTML;
    }
}
